function accordion () {
	const accordion = document.querySelector('[data-jsmodule="lpAccordion"]');

	if (accordion) {
		const items = document.querySelectorAll('[data-togglecontent-button]');

		items.forEach((item) => {
			item.addEventListener('click', (e) => {
				// eslint-disable-next-line no-unused-expressions
				e.preventDefault;
				toggleAccordion(item, items);
			});
		});
	}
}

export default accordion;

function toggleAccordion (item, items) {
	const itemToggle = item.getAttribute('aria-expanded');

	for (let i = 0; i < items.length; i++) {
		items[i].setAttribute('aria-expanded', 'false');
		items[i].nextElementSibling.style.maxHeight = '0';
	}

	if (itemToggle === 'false') {
		item.setAttribute('aria-expanded', 'true');
		const content = item.nextElementSibling.querySelector('[data-togglecontent-content]');
		const contentHeight = content.getBoundingClientRect().height;
		console.log(contentHeight);
		item.nextElementSibling.style.maxHeight = `${contentHeight}px`;
	}
}
